import React from 'react'
import Terms from 'app/components/checkout/steps/partials/Terms'

const router = require('app/services/router')
const Trans = require('app/components/trans/Trans')
const env = require("app/services/env")

export default class PaymentTerms extends Terms {
  get type () {
    return  translate('handelsbetingelserne')
  }

  get urlToTerms () {
    return router.route('page.show', { pagePath: env.get('checkout.special_page_slugs.sales_terms', '') })
  }

  get checkboxId () {
    return 'termsOfTradeCheckbox'
  }

  renderLabelContents () {
    return (
      <>
        <Trans replace={{termsType: this.type}}>Jeg har læst og accepterer <a target='_blank' href={this.urlToTerms}>:termsType</a></Trans>
      </>
    )
  }

  renderTerms () {
    return (
      <>
        <div className='payment-terms-text'>
          <p><Trans>Ved levering til begravelse, garanterer vi altid levering til tiden, forudsat bestillingen er afgivet i
            overensstemmelse med vores salgs- og leveringsbetingelser.</Trans>
          </p>
          <p><Trans>Ved levering på et bestemt tidspunkt på dagen ved øvrige ordrer, garanterer vi ikke, at der sker levering på
            det ønskede tidspunkt på dagen, men vi gør alt hvad der er muligt for at opfylde ønsket herom.</Trans>
          </p>
          <p><Trans>Ved levering tages der forbehold for ekstreme vejrsituationer som fx sne, is og vejrlig i øvrigt.</Trans></p>
        </div>
      </>
    )
  }
}
